/**
 * The single definition of "this staff row still owes a role choice" (#2340, #2525).
 *
 * The sign-in gate (src/context/AuthContext.tsx) and the role-selection route
 * (src/app/api/onboarding/complete-role-selection/route.ts) must agree on which
 * organization_staff rows are pending, or the screen names one gym while the write
 * lands on another. They used to agree only by DATA: the gate filtered
 * `.eq('onboarding_completed', false)` (which does NOT match NULL) while the route
 * used `!row.onboarding_completed` (which DOES). Prod has no NULLs today, so the
 * disagreement was unobservable — a NULL row would have been written by the route but
 * never gated at sign-in.
 *
 * Both sides now key off the constant below, so they agree by construction.
 */
export const ROLE_SELECTION_PENDING_VALUE = false;

export function isRoleSelectionPending(row: { onboarding_completed: boolean | null }): boolean {
  return row.onboarding_completed === ROLE_SELECTION_PENDING_VALUE;
}
